import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { device } from '../device';

const Circle = styled.div`
    cursor: pointer;
    height: 76px;
    width: 76px;
    background-color: ${props => props.isSelected ? '#000000' : '#FFFFFF'};
    border-radius: 50%;
    border: solid 2px black;
    transition: 0.5s;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        background-color: black;
        transition: 0.5s;       
        p {
            color: #FFFFFF !important;
        }
    }
    @media (max-width: 575px) {
        height: 50px;
        width: 50px;
    }
`;

const Number = styled.p`
    font-weight: 500;
    color: ${props => props.isSelected ? '#FFFFFF' : '#000000'};
    transition: 0.3s;
    font-size: 1.9em;
    text-align: center;
    margin: 0;
    @media (max-width: 575px) {
        font-size: 1.5em;
    }
`;

const Header = styled.h5`
    text-align: center;
    @media ${device.tablet} {
        display: none;
    }
`;

const PointLine = (props) => {
    const [isSelected, setSelected] = useState(false);

    useEffect(() => {
        setSelected(props.active === props.data.id);
    }, [props.data.id, props.active]);

    return (
        <>
            <Circle isSelected={isSelected} data-id={props.data.id}>
                <Number isSelected={isSelected} data-id={props.data.id}>{props.data.id}</Number>
            </Circle>
            <Header>{props.data.title}</Header>
        </>
    );
};

export default PointLine;
